function getInitialState() {
    return {
        event: {}
    };
}

function EventReducer(state = getInitialState(), action = null) {
    switch (action.type) {
    default:
        return state;
    }
}

export default EventReducer;
